export default __webpack_public_path__ + "static/media/proj3_8.218d3a78.jpg";